import React from "react";
import HeroImg from "../components/Home/HeroImg";
import MyCard from "../components/Home/MyCard";

const Home = () => {
  return (
    <div>
      <HeroImg />
      <MyCard />
    </div>
  );
};

export default Home;
